import React from 'react';
import { useTranslation } from 'react-i18next';
import { DurationTicker } from 'components/DurationTicker';
import { useSelector } from 'react-redux';
import { getMachineOperationalStatusSinceIndicator } from 'lib/selectors/getMachineOperationalStatusSinceIndicator';
import { CustomClockRegular } from 'components/CustomClockRegular';
import { Container, Body, Subtitle, Title, Header } from './styled';
import ShiftIndicator from './ShiftIndicator';
import { DURATION_FORMAT, DURATION_OPTIONS } from '../Tabs/constants';

const WaitingForWork = () => {
  const { t } = useTranslation();

  const since = useSelector(getMachineOperationalStatusSinceIndicator);

  return (
    <Container className="waiting-for-work">
      <Header>
        <ShiftIndicator />
      </Header>
      <Body>
        <Title>{t('Waiting for Work')}</Title>
        <Subtitle>
          <CustomClockRegular
            autoPlay
            autoPlayMinuteInterval={100}
            autoPlayMinuteStep={1}
          />
          {since && (
            <DurationTicker
              startDate={since}
              format={DURATION_FORMAT}
              formatOptions={{ ...DURATION_OPTIONS, trim: 'small' }}
            />
          )}
        </Subtitle>
      </Body>
    </Container>
  );
};

export default WaitingForWork;
